export default "__VITE_ASSET__DiuvFXYp__"